import { ChevronDown, ChevronLeft } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

export default function MainTrackVoluntier() {
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);

  const data = [
    {
      id: 1,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 2,
      name: "Ethan Miller",
      role: "Volunteer Organizer",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 3,
      name: "Olivia Davis",
      role: "Cleanup Crew",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 4,
      name: "Noah Wilson",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 5,
      name: "Isabella Rodriguez",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 6,
      name: "Lucas Young",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 7,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 8,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 9,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 10,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 11,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
    {
      id: 12,
      name: "Sophia Clark",
      role: "Event Coordinator",
      hour: "20",
      tag: "Green Earth Initiative",
      status: "Active",
    },
  ];

  const statusClasses = (status) => {
    switch ((status || "").toLowerCase()) {
      case "active":
        return "bg-[#3FE36B] text-black";
      case "scheduled":
        return "bg-[#FFC400] text-[#121717]";
      case "expired":
        return "bg-[#DD0000] text-white";
      default:
        return "bg-sky-100 text-sky-700 ring-1 ring-sky-200";
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="mb-6">
      <div>
        <div className="flex items-center gap-x-1 -ml-[6px]">
          <Link to={"/dashboard/new-request"}>
            <ChevronLeft size={24} />
          </Link>
          <h1 className="font-popinsBold text-xl lg:text-2xl">
            Volunteer Sharing Tracker
          </h1>
        </div>
        <p className="font-popinsRegular text-sm text-black/50 mt-2">
          Track volunteer sharing between organizations
        </p>
      </div>

      <div className="flex space-x-4 mt-5" ref={menuRef}>
        {/* Location Menu */}
        <div className="relative">
          <button
            className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] shadow-sm hover:bg-gray-100 focus:outline-none flex items-center text-sm gap-x-2"
            onClick={() =>
              setOpenMenu(openMenu === "location" ? null : "location")
            }
          >
            Event: Community Cleanup
            <ChevronDown size={20} />
          </button>
          {openMenu === "location" && (
            <ul className="absolute mt-1 w-56 bg-[#F0F2F5] text-[#121417] text-sm border rounded-md font-popinsRegular shadow-lg z-50">
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                onClick={() => {
                  console.log("Location: New York");
                  setOpenMenu(null);
                }}
              >
                New York
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/1"
                onClick={() => {
                  console.log("Location: Los Angeles");
                  setOpenMenu(null);
                }}
              >
                Los Angeles
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  console.log("Location: Chicago");
                  setOpenMenu(null);
                }}
              >
                Chicago
              </li>
            </ul>
          )}
        </div>

        {/* Services Menu */}
        <div className="relative">
          <button
            className="px-4 py-2 border rounded-md text-[#121417] font-popinsMedium cursor-pointer bg-[#F0F2F5] flex items-center text-sm gap-x-2 shadow-sm hover:bg-gray-100 focus:outline-none"
            onClick={() =>
              setOpenMenu(openMenu === "services" ? null : "services")
            }
          >
            Organization: Green Earth Initiative
            <ChevronDown size={20} />
          </button>
          {openMenu === "services" && (
            <ul className="absolute mt-1 w-56 text-[#121417] bg-[#F0F2F5] font-popinsRegular text-sm rounded-md shadow-lg z-50">
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                onClick={() => {
                  console.log("Services Offered: Cleaning");
                  setOpenMenu(null);
                }}
              >
                Cleaning
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-black/10"
                onClick={() => {
                  console.log("Services Offered: Delivery");
                  setOpenMenu(null);
                }}
              >
                Delivery
              </li>
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  console.log("Services Offered: Support");
                  setOpenMenu(null);
                }}
              >
                Support
              </li>
            </ul>
          )}
        </div>
      </div>

      <div className="overflow-x-auto mt-8 rounded-xl">
        <table className="hidden md:table w-full text-sm border border-border rounded-xl">
          <thead className="bg-white/50 sticky top-0 border-b border-border !font-popinsRegular">
            <tr>
              <th className="text-left w-[25%] py-3 px-4">Volunteer Name</th>
              <th className="w-[15%] py-3 text-center">Role</th>
              <th className="text-center w-[15%] py-3">Hours</th>
              <th className="text-center w-[25%] py-3">Organization Tag</th>
              <th className="text-center w-[20%] py-3">Status</th>
            </tr>
          </thead>
          <tbody className="">
            {data.map((row) => (
              <tr
                key={row.id}
                className="bg-white/60 font-popinsMedium border-b border-border hover:bg-gray-50"
              >
                <td className="px-4 py-3">{row.name}</td>

                <td className="py-3 text-center text-black/50">{row.role}</td>
                <td className="py-3 text-center text-black/50">{row.hour}</td>
                <td className="py-3 text-center">
                  <div className="bg-gray-200 flex justify-center items-center px-5 py-[10px] rounded-lg">
                    {row.tag}
                  </div>
                </td>
                <td className="px-2 py-3">
                  <span
                    className={`flex justify-center items-center py-[10px] rounded-lg text-sm font-popinsMedium ${statusClasses(
                      row.status
                    )}`}
                  >
                    <span className="w-2 h-2 rounded-full" aria-hidden></span>
                    {row.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="md:hidden space-y-3">
          {data.map((row) => (
            <div
              key={row.id}
              className="bg-white/80 p-4 rounded-xl shadow-sm border border-border hover:shadow-md transition-shadow duration-200 cursor-pointer"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <div className="flex items-center gap-2">
                    <p className="font-popinsMedium text-sm">{row.name}</p>
                  </div>
                  <div className="mt-3 flex flex-wrap items-center gap-2">
                    <span
                      className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-popinsMedium ${statusClasses(
                        row.status
                      )}`}
                    >
                      {row.status}
                    </span>
                    <div className="text-sm text-black/50 font-popinsMedium">
                      Role: {row.role}
                    </div>
                    <div className="text-sm text-black/50 font-popinsMedium">
                      Hour: {row.hour}
                    </div>
                    <div className="text-sm text-black/50 font-popinsMedium">
                      Organization Tag: {row.tag}
                    </div>
                  </div>
                </div>

                <div className="flex flex-col items-end gap-2"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
